/**
 * Règles d'affichage / désactivation liées au plafond de séances par client
 * (prestation « pack » ou achat unique).
 */
export const isSessionPackExhausted = (
  maxBookingsPerClient: number | null | undefined,
  remainingBookings: number | null | undefined,
): boolean => {
  const hasLimit = (maxBookingsPerClient ?? 0) > 0;
  return (
    hasLimit &&
    remainingBookings !== null &&
    remainingBookings !== undefined &&
    remainingBookings <= 0
  );
};

export const shouldShowSessionPackRemaining = (
  maxBookingsPerClient: number | null | undefined,
  remainingBookings: number | null | undefined,
): remainingBookings is number => {
  return (
    (maxBookingsPerClient ?? 0) > 0 &&
    remainingBookings !== null &&
    remainingBookings !== undefined
  );
};
